export const getters = {
  getAuthError(state) {
    return state.authError;
  },

  getUserProfile(state) {
    return state.userProfile
  }
}
